import * as Preact from "preact"
import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import Director from "@frog/source/juice/Director.js"
import manifest from "@frog/source/manifest.js"

import encounters from "@frog/source/data/encounters/encounters.js" // imported for loading encounters.

import "@frog/source/views/app/screens/SplashScreen.view.less"
import OverworldScreen from "./OverworldScreen.view.js"

export default class SplashScreen {
    render() {
        return (
            <div class="SplashScreen">
                <section class="TitleSection" onClick={this.onClick}>
                </section>
            </div>
        )
    }
    onClick() {
        Navigation.go("/game/encounters/level1")
    }
}
